import React from "react";
import PortableText from "@sanity/block-content-to-react";

const serializers = {
    marks: {
        internalLink: ({ mark, children }) => {
            const { slug = {} } = mark;
            const href = `/${slug.current}`;
            return (
                <a className="default-link" href={href}>
                    {children}
                </a>
            );
        },
    },
};

const FormattedText = (props) => (
    <div className="textBlock">
        <PortableText blocks={props.blocks} serializers={serializers} />
    </div>
);

export default FormattedText;
